<template>
	<div
		class="relative shrink-0 overflow-hidden rounded-lg p-2"
		:class="{
			'bg-fill-tertiary': alt,
			'bg-fill-secondary': !alt
		}"
	>
		<svg
			width="56"
			height="56"
			viewBox="0 0 56 56"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			class="absolute inset-0.5"
			v-if="!noBackdrop && size === 'md'"
		>
			<mask
				id="mask0_740_3786"
				style="mask-type: alpha"
				maskUnits="userSpaceOnUse"
				x="0"
				y="0"
				width="56"
				height="56"
			>
				<rect
					x="56"
					y="56"
					width="56"
					height="56"
					transform="rotate(180 56 56)"
					fill="url(#paint0_radial_740_3786)"
				/>
			</mask>
			<g mask="url(#mask0_740_3786)">
				<path
					opacity="0.1"
					d="M-307.778 -38.1904H444.407V-36.5547H-307.778V-38.1904ZM-307.778 -22.6914H444.407V-21.0557H-307.778V-22.6914ZM-307.778 -7.19141H444.407V-5.55566H-307.778V-7.19141ZM-307.778 8.30762H444.407V9.94336H-307.778V8.30762ZM-307.778 16.0576H444.407V17.6934H-307.778V16.0576ZM-307.778 23.8076H444.407V25.4434H-307.778V23.8076ZM-307.778 31.5566H444.407V33.1924H-307.778V31.5566ZM-307.778 39.3066H444.407V40.9424H-307.778V39.3066ZM-307.778 47.0566H444.407V48.6924H-307.778V47.0566Z"
					fill="#878787"
				/>
			</g>
			<defs>
				<radialGradient
					id="paint0_radial_740_3786"
					cx="0"
					cy="0"
					r="1"
					gradientUnits="userSpaceOnUse"
					gradientTransform="translate(84 84) rotate(180) scale(28 27.9282)"
				>
					<stop offset="0.246979" stop-color="#0A1119" />
					<stop offset="1" stop-color="#33567F" stop-opacity="0" />
				</radialGradient>
			</defs>
		</svg>
		<svg
			width="48"
			height="48"
			viewBox="0 0 48 48"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			class="absolute inset-0"
			v-if="!noBackdrop && size === 'sm'"
		>
			<mask
				id="mask0_1272_2734"
				style="mask-type: alpha"
				maskUnits="userSpaceOnUse"
				x="0"
				y="0"
				width="48"
				height="48"
			>
				<rect
					x="48"
					y="48"
					width="48"
					height="48"
					transform="rotate(180 48 48)"
					fill="url(#paint0_radial_1272_2734)"
				/>
			</mask>
			<g mask="url(#mask0_1272_2734)">
				<path
					opacity="0.1"
					d="M-263.809 7.12109H380.92V8.52246H-263.809V7.12109ZM-263.809 13.7637H380.92V15.166H-263.809V13.7637ZM-263.809 20.4062H380.92V21.8086H-263.809V20.4062ZM-263.809 27.0488H380.92V28.4502H-263.809V27.0488ZM-263.809 33.6914H380.92V35.0938H-263.809V33.6914ZM-263.81 40.334H380.92V41.7363H-263.81V40.334Z"
					fill="#878787"
				/>
			</g>
			<defs>
				<radialGradient
					id="paint0_radial_1272_2734"
					cx="0"
					cy="0"
					r="1"
					gradientUnits="userSpaceOnUse"
					gradientTransform="translate(72 72) rotate(180) scale(24 23.9385)"
				>
					<stop offset="0.246979" stop-color="#0A1119" />
					<stop offset="1" stop-color="#33567F" stop-opacity="0" />
				</radialGradient>
			</defs>
		</svg>

		<LazyImage
			v-if="!src.includes('.tgs')"
			:class="{
				'h-8 w-8': size === 'sm',
				'h-11 w-11': size === 'md'
			}"
			:src="src"
			:alt="name"
			:preloader="preloader || undefined"
		/>
		<LazySticker
			v-else
			:class="{
				'h-8 w-8': size === 'sm',
				'h-11 w-11': size === 'md'
			}"
			:src="src"
			:alt="name"
			:preloader="preloader || undefined"
			autoplay
		/>
	</div>
</template>
<script setup lang="ts">
import LazyImage from './LazyImage.vue'
import LazySticker from './LazySticker.vue'

withDefaults(
	defineProps<{
		src: string
		name: string
		noBackdrop?: boolean
		alt?: boolean
		preloader?: string
		size?: 'sm' | 'md'
	}>(),
	{
		size: 'md'
	}
)
</script>
